<script setup lang="ts">
import TextInput from "./TextInput.vue";
import MultipleUpload from "./MultipleUpload.vue";
import TextareaInput from "./TextareaInput.vue";

defineProps<{
  formType: string;
}>();
</script>
<template>
  <h1 class="title my-3 text-base md:text-lg 2xl:text-xl">Reintegro</h1>

  <div
    class="grid grid-cols-1 md:grid-cols-2 border-section py-4 2xl:py-8 px-4 md:px-8 2xl:px-12 gap-y-2 2xl:gap-y-6 gap-x-9"
  >
    <div class="md:col-span-2 md:mb-8">
      <h1
        class="mb-2 font-bold font-montserrat text-[13px] md:text-xl 2xl:text-2xl text-grayDetails-400"
      >
        Te devolvemos el gasto correspondiente a tu tope de cobertura
      </h1>
      <h2
        class="font-montserrat font-medium text-xs 2xl:text-sm text-grayDetails-400"
      >
        Completá tus datos para que podamos realizar el pago y cargá el ticket o
        factura.
      </h2>
    </div>

    <div class="flex flex-col gap-2 md:gap-6">
      <TextInput
        name="holder_person"
        label="Titular de la cuenta"
        type="text"
        class="title font-medium text-xs md:text-sm 2xl:text-base"
        read-only
      />

      <TextInput
        name="cuil"
        label="Número de CUIL"
        type="text"
        class="title font-medium text-xs md:text-sm 2xl:text-base"
      />
    </div>

    <div class="flex flex-col gap-2 md:gap-6">
      <TextInput
        name="cbu"
        label="Número de CBU"
        type="text"
        class="title font-medium text-xs md:text-sm 2xl:text-base"
      />
      <TextareaInput
        name="comment"
        label="Detalle del reintegro"
        class="text-xs md:text-base"
        rows="1"
        placeholder="Motivo de la solicitud..."
      />
    </div>

    <div class="md:col-span-2 mt-4 md:mt-8">
      <MultipleUpload
        name="imagenes"
        label-button="Hacé click y subí tu ticket o factura"
        :form-type="formType"
      />
    </div>
  </div>
</template>

<style scoped></style>
